import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import extendedPropertyUri from 'owa-service/lib/factory/extendedPropertyUri';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import { getExtendedPropertyUri } from 'owa-service/lib/Utils';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { inlineImageCustomDataTemplate, inlineImageUrlOnLoadTemplate, inlineImageUrlTemplate, } from 'owa-inline-image-consts';
export var cssScopeClassName = 'rps_' + getRandomBetween(1, 0xffff).toString(16);
export var maximumBodySize = 2 * 1024 * 1024;
export var maximumRecipientsToReturn = 20;
var EXPLICIT_MESSAGE_CARD_PROPERTY_NAME = 'ExplicitMessageCard';
var COMMON_PROPERTY_SET_GUID = '00062008-0000-0000-C000-000000000046';
function getRandomBetween(min, max) {
    return Math.ceil(Math.random() * (max - min) + min);
}
function getBlockContentFromUnknownSenders() {
    var userConfiguration = getUserConfiguration();
    return userConfiguration.SafetyUserOptions
        ? userConfiguration.SafetyUserOptions.BlockContentFromUnknownSenders
        : false;
}
export function getComposeItemResponseShape(bodyType) {
    var shape = itemResponseShape({
        BaseShape: 'IdOnly',
        ClientSupportsIrm: true,
        FilterHtmlContent: true,
        InlineImageCustomDataTemplate: inlineImageCustomDataTemplate,
        // Bug 25298: Compose send may accidentally include inline image place holder
        // https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/25298
        // ComposeItemResponseShape is used for requesting item to be loaded in compose, i.e. draft
        // In the past, we trigger inline image load through injecting client side javascript reference
        // "onload=InlineImageLoader.GetLoader().Load(this)" just like reading pane. This causes a place holder
        // to be displayed and may accidently be sent out if users send too fast before image loads
        // The fix is to not to rely on this script injection, but to hook on editor ContentChange event
        // and fire up inline image load programatically where we can control using of place holder
        InlineImageUrlOnLoadTemplate: '',
        InlineImageUrlTemplate: inlineImageUrlTemplate,
        AdditionalProperties: [propertyUri({ FieldURI: 'ItemLastModifiedTime' })],
    });
    if (bodyType) {
        shape.BodyType = bodyType;
    }
    if (isMailFeatureEnabled('rp-replyImageProxy')) {
        shape.ImageProxyCapability = 'OwaConnectorsProxyAndCompose';
    }
    return shape;
}
export function getBaseItemResponseShape() {
    return itemResponseShape({
        BaseShape: 'IdOnly',
        AddBlankTargetToLinks: true,
        BlockContentFromUnknownSenders: getBlockContentFromUnknownSenders(),
        BlockExternalImagesIfSenderUntrusted: true,
        ClientSupportsIrm: true,
        CssScopeClassName: cssScopeClassName,
        FilterHtmlContent: true,
        FilterInlineSafetyTips: true,
        InlineImageCustomDataTemplate: inlineImageCustomDataTemplate,
        InlineImageUrlOnLoadTemplate: inlineImageUrlOnLoadTemplate,
        InlineImageUrlTemplate: inlineImageUrlTemplate,
        MaximumBodySize: maximumBodySize,
        MaximumRecipientsToReturn: maximumRecipientsToReturn,
        ImageProxyCapability: 'OwaAndConnectorsProxy',
        AdditionalProperties: [
            propertyUri({ FieldURI: 'CanDelete' }),
            extendedPropertyUri(getExtendedPropertyUriForExplicitMessageCard()),
        ],
    });
}
function getExtendedPropertyUriForExplicitMessageCard() {
    return getExtendedPropertyUri(COMMON_PROPERTY_SET_GUID, EXPLICIT_MESSAGE_CARD_PROPERTY_NAME, 'String');
}
//# sourceMappingURL=getItemResponseShape.js.map